import './Social.scss';

import classnames from 'classnames';
import LinkExternal from 'components/partials/links/components/link-external/LinkExternal';
import { SOCIAL } from 'config/core';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  className: PropTypes.string
};

const Social = ({ className }) => {
  const { twitter, facebook, instagram, linkedin, youtube } = SOCIAL;
  return twitter || facebook || instagram || linkedin || youtube ? (
    <p className={classnames('social-nav', className)}>
      {facebook && (
        <LinkExternal to={facebook} title="facebook">
          <i className="icon-facebook"></i>
        </LinkExternal>
      )}
      {instagram && (
        <LinkExternal to={instagram} title="instagram">
          <i className="icon-instagram"></i>
        </LinkExternal>
      )}
      {twitter && (
        <LinkExternal to={twitter} title="twitter">
          <i className="icon-twitter"></i>
        </LinkExternal>
      )}
      {linkedin && (
        <LinkExternal to={linkedin} title="linkedin">
          <i className="icon-linkedin"></i>
        </LinkExternal>
      )}
      {youtube && (
        <LinkExternal to={youtube} title="youtube">
          <i className="icon-youtube"></i>
        </LinkExternal>
      )}
    </p>
  ) : null;
};

Social.propTypes = propTypes;

export default Social;
